
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.583 2C6.58297 2 2.24963 3.08333 2.24963 5.33333C2.24963 7.58333 6.58297 8.66667 10.583 8.66667C14.583 8.66667 18.9163 7.58333 18.9163 5.33333C18.9163 3.08333 14.583 2 10.583 2ZM2.24963 8.33331C4.1663 9.74998 7.4163 10.3333 10.583 10.3333C13.7496 10.3333 16.9996 9.74998 18.9163 8.33331V11.1044C18.5378 11.0358 18.1479 11 17.7496 11C14.9287 11 12.5274 12.797 11.6282 15.3088C11.2793 15.3252 10.9299 15.3333 10.583 15.3333C6.58297 15.3333 2.24963 14.25 2.24963 12V8.33331ZM11.2693 16.9908C11.0404 16.997 10.8115 17 10.583 17C7.4163 17 4.1663 16.4167 2.24963 15V18.6667C2.24963 20.9167 6.58297 22 10.583 22C11.3681 22 12.1661 21.9583 12.9416 21.8742C11.8904 20.7194 11.2496 19.1845 11.2496 17.5C11.2496 17.3286 11.2563 17.1588 11.2693 16.9908Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M16.2 15H15V16.2H16.2V15ZM15 14H14V15V16.2V17.2H15H16.2H17.2V16.2V15V14H16.2H15ZM19.8 20.4C19.8 20.7314 20.0686 21 20.4 21C20.7314 21 21 20.7314 21 20.4C21 20.0686 20.7314 19.8 20.4 19.8C20.0686 19.8 19.8 20.0686 19.8 20.4ZM20.4 18.8C19.5163 18.8 18.8 19.5163 18.8 20.4C18.8 21.2837 19.5163 22 20.4 22C21.2837 22 22 21.2837 22 20.4C22 19.5163 21.2837 18.8 20.4 18.8ZM18 16.1H18.4C19.2284 16.1 19.9 16.7716 19.9 17.6V18H20.9V17.6C20.9 16.2193 19.7807 15.1 18.4 15.1H18V16.1ZM16.1 18.4V18H15.1V18.4C15.1 19.7807 16.2193 20.9 17.6 20.9H18V19.9H17.6C16.7716 19.9 16.1 19.2284 16.1 18.4Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowdatastreamFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
